import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Calendar, Ticket, ExternalLink } from 'lucide-react';
import { Button } from './ui/Button';
interface Props {
  isOpen: boolean;
  onClose: () => void;
}
interface TicketType {
  name: string;
  earlyPrice: string;
  regularPrice: string;
  registrationUrl: string;
}
const TICKET_TYPES: TicketType[] = [{
  name: 'אדם בחדר זוגי + כרטיס',
  earlyPrice: '1,190',
  regularPrice: '1,322',
  registrationUrl: 'https://www.enerchi.co.il/category/%D7%98%D7%95%D7%A4%D7%A1-%D7%94%D7%A8%D7%A9%D7%9E%D7%94-%D7%9C%D7%90%D7%93%D7%9D-%D7%91%D7%97%D7%93%D7%A8'
}, {
  name: 'אדם בחדר טריפל + כרטיס',
  earlyPrice: '1,190',
  regularPrice: '1,322',
  registrationUrl: '' // תמלאי מאוחר יותר
}, {
  name: 'לילה של חמישי בחדר זוגי + כרטיס',
  earlyPrice: '834',
  regularPrice: '927',
  registrationUrl: '' // תמלאי מאוחר יותר
}, {
  name: 'לילה של שישי בחדר זוגי + כרטיס',
  earlyPrice: '891',
  regularPrice: '990',
  registrationUrl: '' // תמלאי מאוחר יותר
}, {
  name: 'חדר זוגי לבד + כרטיס',
  earlyPrice: '940',
  regularPrice: '1,034',
  registrationUrl: '' // תמלאי מאוחר יותר
}, {
  name: 'לילה של חמישי לחדר זוגי לבד + כרטיס',
  earlyPrice: '850',
  regularPrice: '935',
  registrationUrl: '' // תמלאי מאוחר יותר
}, {
  name: 'לילה של שישי לחדר זוגי לבד + כרטיס',
  earlyPrice: '890',
  regularPrice: '979',
  registrationUrl: '' // תמלאי מאוחר יותר
}, {
  name: 'כרטיס לפסטיבל בלבד',
  earlyPrice: '410',
  regularPrice: '485',
  registrationUrl: 'https://www.enerchi.co.il/category/%D7%94%D7%A8%D7%A9%D7%9E%D7%94-%D7%9C%D7%A4%D7%A1%D7%98%D7%99%D7%91%D7%9C-%D7%97%D7%AA%D7%99%D7%A8%D7%94'
}];
export function WaterTribeFestTicketSelection({
  isOpen,
  onClose
}: Props) {
  const handleTicketClick = (url: string) => {
    if (url) {
      window.open(url, '_blank');
    } else {
      alert('קישור ההרשמה יתווסף בקרוב');
    }
  };
  return <AnimatePresence data-id="element-835" data-mp="219y5fuyccg5t">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" data-id="element-836" data-mp="2qxk299j0944i" />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-837" data-mp="2zqx450z1rg2q">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-white rounded-3xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto pointer-events-auto" onClick={e => e.stopPropagation()} data-id="element-838" data-mp="34ndum1tpy6iz">
              {/* Header */}
              <div className="sticky top-0 bg-gradient-to-br from-[#0A5F8F] to-[#0D7AB8] text-white p-8 rounded-t-3xl z-10" data-id="element-839" data-mp="3se9rvegy1txm">
                <button onClick={onClose} className="absolute top-6 left-6 p-2 hover:bg-white/20 rounded-full transition-colors" data-id="element-840" data-mp="17gny2urngpe">
                  <X className="w-6 h-6" data-id="element-841" data-mp="1lphhwa31j3mg" />
                </button>

                <div className="flex items-center gap-3 mb-4" data-id="element-842" data-mp="1gqo38ec0p6kp">
                  <Ticket className="w-8 h-8" data-id="element-843" data-mp="1gtab6f2tlo3g" />
                  <h2 className="text-3xl md:text-4xl font-bold" data-id="element-844" data-mp="1bz63ftlqdc1b">
                    בחירת כרטיס
                  </h2>
                </div>
                <p className="text-blue-100 text-lg" data-id="element-845" data-mp="16z1viryw1pmp">
                  19-21 בנובמבר 2026 | חוף מעגן עדן, כנרת
                </p>

                {/* Pricing Period Info */}
                <div className="mt-6 inline-flex items-center gap-3 bg-white/20 backdrop-blur-md px-6 py-3 rounded-full border border-white/30" data-id="element-846" data-mp="xyvbsocljtf3">
                  <Calendar className="w-5 h-5" data-id="element-847" data-mp="o2igxn5bf9ir" />
                  <div className="text-right text-sm" data-id="element-848" data-mp="o3tkpmyrgh9v">
                    <div className="font-bold" data-id="element-849" data-mp="2nfwdjnt9yo07">הרשמה מוקדמת עד 10.2</div>
                    <div className="text-blue-100" data-id="element-850" data-mp="2nd0dntxv9p94">הרשמה רגילה מ-11.2</div>
                  </div>
                </div>
              </div>

              {/* Tickets Grid */}
              <div className="p-8 space-y-4" data-id="element-851" data-mp="2qhit2e1izbon">
                {TICKET_TYPES.map((ticket, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: index * 0.05
            }} onClick={() => handleTicketClick(ticket.registrationUrl)} className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-6 border-2 border-blue-100 hover:border-[#0A5F8F] hover:shadow-lg transition-all cursor-pointer group" data-id="element-852" data-mp="2verb8emobfpw" data-mpi={index}>
                    <div className="flex items-center justify-between gap-4" data-id="element-853" data-mp="1xt3cvo6nqnbq">
                      <div className="flex-1" data-id="element-854" data-mp="22r56v45mg71z">
                        <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-855" data-mp="22rwqrhpuwgcf">
                          {ticket.name}
                        </h3>
                        <div className="flex items-center gap-4 text-sm" data-id="element-856" data-mp="1ssz6iqzgr8z8">
                          <div className="flex items-center gap-2" data-id="element-857" data-mp="1svbjepqd6t5f">
                            <span className="text-gray-600" data-id="element-858" data-mp="1a5q0ww2nuhuk">הרשמה מוקדמת:</span>
                            <span className="font-bold text-indigo-600 text-lg" data-id="element-859" data-mp="156lu2c37kw7e">
                              ₪{ticket.earlyPrice}
                            </span>
                          </div>
                          <div className="h-4 w-px bg-gray-300" data-id="element-860" data-mp="1e68sqq4jznwr" />
                          <div className="flex items-center gap-2" data-id="element-861" data-mp="1t3svrrhw390a">
                            <span className="text-gray-600" data-id="element-862" data-mp="1t1ya2aysncv5">הרשמה רגילה:</span>
                            <span className="font-bold text-purple-600 text-lg" data-id="element-863" data-mp="1o3wpfllpz5hk">
                              ₪{ticket.regularPrice}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center gap-2 text-[#0A5F8F] group-hover:text-cyan-600 transition-colors" data-id="element-864" data-mp="2bu0ttv6qf99m">
                        <span className="font-medium text-sm" data-id="element-865" data-mp="26vz08gbojrjw">בחר</span>
                        <ExternalLink className="w-5 h-5" data-id="element-866" data-mp="14hrl54bszhv4" />
                      </div>
                    </div>
                  </motion.div>)}
              </div>

              {/* Footer Note */}
              <div className="p-8 pt-0" data-id="element-867" data-mp="1dig50fnvocfx">
                <div className="bg-amber-50 border-2 border-amber-200 rounded-2xl p-6 text-center" data-id="element-868" data-mp="1dheo3uk6kvqa">
                  <p className="text-gray-700" data-id="element-869" data-mp="1i9y4eza964ys">
                    <span className="font-bold text-amber-600" data-id="element-870" data-mp="1n89e9a0jsfh0">💡 טיפ:</span>{' '}
                    חסכו עד 100 ₪ בהרשמה מוקדמת עד ה-10.2!
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}